import {
  ChangeDetectionStrategy,
  Component,
  Inject,
  OnDestroy,
  OnInit,
  TemplateRef,
  ViewChild,
} from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialogActions,
  MatDialogClose,
  MatDialogContent,
  MatDialogRef,
  MatDialogTitle,
} from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { MatButtonModule } from '@angular/material/button';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { MatCardModule } from '@angular/material/card';
import { GenerateClassificationService } from '../../services/generate-classification.service';
import { ToastrService } from 'ngx-toastr';
import { CsvExportService } from '../../services/csv-export.service';
import { CsvZipExportService } from '../../services/csv-zip-export.service';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';

export interface DescriptionElement {
  DATABASE: 'string';
  SCHEMA: 'string';
  TABLE_NAME: 'string';
  COLUMN_NAME: 'string';
  DATA_TYPE: 'string';
  TAG_VALUE: 'string';
  DESCRIPTION: 'string';
}

@Component({
  selector: 'app-generate-description',
  templateUrl: './generate-description.component.html',
  styleUrl: './generate-description.component.scss',
})
export class GenerateDescriptionComponent implements OnInit, OnDestroy {
  currentActiveTab: string = 'databases';
  selectedDatabase: boolean = false;
  selectedSchema: boolean = false;
  selectedTable: boolean = false;
  currentActiveRowIndex: number = -1;
  enableEditing: boolean = false;
  displayedColumns: string[] = [
    'select',
    'columnName',
    'originalDescription',
    'customInstruction',
    'aiGeneratedDescription',
    'aiGeneratedClassification',
    'aiReasoning',
    'confidenceScore',
    'action',
  ];
  dataSource = new MatTableDataSource<DescriptionElement>([]);
  fetchedResponse: any = [];
  descriptionLoading: boolean = false;
  private dialogRef?: MatDialogRef<any>;
  @ViewChild('downloadOptionDialog') downloadOptionDialog!: TemplateRef<any>;

  databases = [];
  schemas = [];
  tables = [];
  metadata: any = [];
  newResponse: any = [];
  current_processed_metadata: any = {};
  original_metadata: any = {};
  isInputDisabled: boolean = true;
  @ViewChild('columnDescriptionDialog')
  columnDescriptionDialog!: TemplateRef<any>;
  columnDescription: string = '';
  columnDescriptionFull: string = '';
  selectedTableForDescription: any;
  selectedColumnForDescription: any;
  private saveMetadataSubscription!: Subscription;
  private atlanBulkDownloadSubscription!: Subscription;
  private regenerateSubscription!: Subscription;

  constructor(
    public dialog: MatDialog,
    private generateClassificationService: GenerateClassificationService,
    private toastr: ToastrService,
    private csv: CsvExportService,
    private zipCsv: CsvZipExportService,
    private router: Router
  ) { }
  ngOnInit(): void {
    this.dataSource = new MatTableDataSource<DescriptionElement>(this.metadata);

    let llm_processing: any = localStorage.getItem('llm_processing');
    let parsed_llm_processing = JSON.parse(llm_processing);

    this.newResponse = [];
    this.fetchedResponse = [...parsed_llm_processing.data.databases];
    let mainResponse = parsed_llm_processing.data.databases;
    for (let i = 0; i < mainResponse.length; i++) {
      let database = mainResponse[i].database_name;
      for (let j = 0; j < mainResponse[i].schemas.length; j++) {
        let schema = mainResponse[i].schemas[j].schema_name;
        for (let k = 0; k < mainResponse[i].schemas[j].tables.length; k++) {
          let table = mainResponse[i].schemas[j].tables[k].table_name;
          const keys = Object.keys(
            mainResponse[i].schemas[j].tables[k].columns
          );

          let columns = [];
          for (let key of keys) {
            if (
              !mainResponse[i].schemas[j].tables[k].columns[key]
                .ai_generated_classification
            ) {
              mainResponse[i].schemas[j].tables[k].columns[
                key
              ].ai_generated_classification = null;
            }
            columns.push({
              column_name: key,
              ai_generated_classification:
                mainResponse[i].schemas[j].tables[k].columns[key]
                  .ai_generated_classification,
              ai_generated_description:
                mainResponse[i].schemas[j].tables[k].columns[key]
                  .ai_generated_description,
              snowflake_description:
                mainResponse[i].schemas[j].tables[k].columns[key]
                  .snowflake_description,
              user_instruction:
                mainResponse[i].schemas[j].tables[k].columns[key]
                  .user_instruction,
              ai_reasoning:
                mainResponse[i].schemas[j].tables[k].columns[key].ai_reasoning,
              confidence_score:
                mainResponse[i].schemas[j].tables[k].columns[key]
                  .confidence_score,
              data_type:
                mainResponse[i].schemas[j].tables[k].columns[key].data_type,
              checked: true,
            });
          }
          this.newResponse.push({
            database_name: database,
            schema_name: schema,
            table_name: table,
            table_metadata: mainResponse[i].schemas[j].tables[k].table_metadata,
            isDomainEditable: false,
            isTableDescriptionEditable: false,
            isBusinessTypeEditable: false,
            dataSource: new MatTableDataSource<any>(columns),
            oldColumns: mainResponse[i].schemas[j].tables[k].columns,
            columns: columns,
            checked: true,
          });
        }
      }
    }
  }

  fetchSchemas() {
    this.currentActiveTab = 'schemas';
    this.selectedDatabase = true;
  }

  fetchTables() {
    this.currentActiveTab = 'tables';
    this.selectedSchema = true;
  }

  fetchMetadata() {
    this.currentActiveTab = 'meta';
    this.selectedTable = true;
  }

  expandSection(section: any) {
    if (section === 'databases') {
      this.currentActiveTab = 'databases';
    } else if (section === 'schemas') {
      this.currentActiveTab = 'schemas';
    } else if (section === 'tables') {
      this.currentActiveTab = 'tables';
    }
  }

  enableEdit(index: number) {
    this.enableEditing = true;
    this.currentActiveRowIndex = index;
  }

  saveRowData(index: number) {
    this.enableEditing = false;
    this.currentActiveRowIndex = index;
  }

  editHeader(type: string, index: number) {
    if (type == 'domain') {
      this.newResponse[index].isDomainEditable = true;
      this.newResponse[index].isTableDescriptionEditable = false;
      this.newResponse[index].isBusinessTypeEditable = false;
    }
    if (type == 'description') {
      this.newResponse[index].isTableDescriptionEditable = true;
      this.newResponse[index].isDomainEditable = false;
      this.newResponse[index].isBusinessTypeEditable = false;
    }
    if (type == 'businessType') {
      this.newResponse[index].isBusinessTypeEditable = true;
      this.newResponse[index].isDomainEditable = false;
      this.newResponse[index].isTableDescriptionEditable = false;
    }
  }

  saveHeader(type: string, index: number) {
    if (type == 'domain') {
      this.newResponse[index].isDomainEditable = false;
    }
    if (type == 'description') {
      this.newResponse[index].isTableDescriptionEditable = false;
    }
    if (type == 'businessType') {
      this.newResponse[index].isBusinessTypeEditable = false;
    }
  }

  saveMetadata() {
    let response = [];

    for (let item of this.newResponse) {
      let localItem: any = {};

      const filteredColumn = item.columns.filter(
        (column: any) => column.checked == true
      );

      if (filteredColumn.length == 0) {
        this.toastr.error(
          'Please select atleast one column of each table to save classification',
          'Error'
        );
        return;
      }

      let selectedColumns: any = [];
      for (let el of filteredColumn) {
        selectedColumns.push(el.column_name);
      }
      const filteredObject = Object.fromEntries(
        Object.entries(item.oldColumns).filter(([key]) =>
          selectedColumns.includes(key)
        )
      );

      let table = {
        table_name: item.table_name,
        table_metadata: item.table_metadata,
        columns: filteredObject,
      };
      let schema = {
        schema_name: item.schema_name,
        tables: [table],
      };
      localItem = {
        database_name: item.database_name,
        schemas: [schema],
      };
      response.push({ databases: [localItem] });
    }
    let payload = {
      metadata_list: response,
    };
    this.saveMetadataSubscription = this.generateClassificationService
      .saveMetadataDescription(payload)
      .subscribe((response: any) => {
        if (response.status == 'success') {
          this.toastr.success('Metadata has been saved', 'Saved');
          this.router.navigate(['/dashboard']);
        }
      });
  }

  atlanBulDownload() {
    let response = [];

    for (let item of this.newResponse) {
      let localItem: any = {};

      const filteredColumn = item.columns.filter(
        (column: any) => column.checked == true
      );

      if (filteredColumn.length == 0) {
        this.toastr.error(
          'Please select atleast one column of classified metadata to download',
          'Error'
        );
        return;
      }

      let selectedColumns: any = [];
      for (let el of filteredColumn) {
        selectedColumns.push(el.column_name);
      }
      const filteredObject = Object.fromEntries(
        Object.entries(item.oldColumns).filter(([key]) =>
          selectedColumns.includes(key)
        )
      );

      let table = {
        table_name: item.table_name,
        table_metadata: item.table_metadata,
        columns: filteredObject,
      };
      let schema = {
        schema_name: item.schema_name,
        tables: [table],
      };
      localItem = {
        database_name: item.database_name,
        schemas: [schema],
      };
      response.push({ databases: [localItem] });
    }
    let payload = {
      metadata_list: response,
    };

    this.atlanBulkDownloadSubscription = this.generateClassificationService.atlanBulkDownload(payload).subscribe({
      next: (res) => {
        const xlsxBlob = new Blob([res.body!], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        });

        const contentDisposition = res.headers.get('Content-Disposition');
        const fileName =
          this.extractFileName(contentDisposition) || 'report.xlsx';

        const url = URL.createObjectURL(xlsxBlob);
        const a = document.createElement('a');
        a.href = url;
        a.download = fileName;
        a.style.display = 'none';
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        URL.revokeObjectURL(url);
        this.dialogRef?.close();
      },
      error: (err) => { },
    });
  }

  // Helper to parse filename from header
  extractFileName(contentDisposition: string | null): string | null {
    if (!contentDisposition) return null;
    const match =
      /filename\*=(?:UTF-8'')?["']?([^\"';]+)["']?/i.exec(contentDisposition) ||
      /filename=["']?([^\"']+)["']?/i.exec(contentDisposition);
    return match?.[1] ?? null;
  }

  onDoubleClickInput() {
    this.isInputDisabled = false;
  }

  exportCsv(filename: string, columns: any): void {
    const columnsToExport = columns.filter(
      (column: any) => column.checked == true
    );

    const transformedData = columnsToExport.map((item: any) => ({
      'Column Name': item.column_name,
      'Snowflake Description': item.snowflake_description,
      'User Instruction': item.user_instruction,
      'AI Generated Description': item.ai_generated_description,
      'AI Generated Classification': item.ai_generated_classification,
      'AI Model Reasoning': item.ai_reasoning,
      'Confidence Score': item.confidence_score + '%'
    }));
    if (transformedData.length == 0) {
      this.toastr.error(
        'Please select atleast one column of classified metadata to download',
        'Error'
      );
      return;
    }
    this.csv.exportToCsv(filename + '.csv', transformedData);
  }

  checkRow(event: any, row: any, item: any) {
    for (let element of this.newResponse) {
      if (
        element.database_name == item.database_name &&
        element.schema_name == item.schema_name &&
        element.table_name == item.table_name
      ) {
        for (let ds of element.columns) {
          if (ds.column_name == row.column_name) {
            row.checked = event.checked;
          }
        }
        const check = element.columns.filter(
          (column: any) => column.checked == false
        );
        if (check.length > 0) {
          element.checked = false;
        } else {
          element.checked = true;
        }
      }
    }
  }

  /** Selects all rows if they are not all selected; otherwise clear selection. */
  toggleAllRows(event: any, item: any) {
    for (let element of this.newResponse) {
      if (
        element.database_name == item.database_name &&
        element.schema_name == item.schema_name &&
        element.table_name == item.table_name
      ) {
        for (let ds of element.columns) {
          ds.checked = event.checked;
        }
      }
    }
  }

  openDialog(): void {
    const dialogRef = this.dialog.open(DialogOverviewExampleDialog, {
      width: '600px',
      data: {},
    });

    dialogRef.afterClosed().subscribe((result) => { });
  }

  deleteTable(
    element: any,
    enterAnimationDuration: string,
    exitAnimationDuration: string
  ): void {
    const dialogRef = this.dialog.open(DeleteTableDescriptionDialog, {
      width: '400px',
      enterAnimationDuration,
      exitAnimationDuration,
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result && result.confirmed) {
        const index = this.newResponse.findIndex(
          (item: any) =>
            item.database_name == element.database_name &&
            item.schema_name == element.schema_name &&
            item.table_name == element.table_name
        );
        if (index > -1) {
          this.newResponse.splice(index, 1);
          this.toastr.error('Metadata has been removed', 'Deleted!');
        }
      } else {
      }
    });
  }

  closeDescriptionDialog(): void {
    this.dialogRef?.close();
    this.selectedColumnForDescription = null;
    this.selectedTableForDescription = null;
  }

  clearDescription(): void {
    this.columnDescriptionFull = '';
  }

  saveDescription(): void {
    this.columnDescription =
      this.columnDescriptionFull?.length > 200
        ? this.columnDescriptionFull.substring(0, 197) + '...'
        : this.columnDescriptionFull;

    for (let [index, element] of this.newResponse.entries()) {
      if (
        element.database_name ==
        this.selectedTableForDescription.database_name &&
        element.schema_name == this.selectedTableForDescription.schema_name &&
        element.table_name == this.selectedTableForDescription.table_name
      ) {
        for (let ds of element.columns) {
          if (ds.column_name == this.selectedColumnForDescription.column_name) {
            ds.user_instruction = this.columnDescription;
          }
        }
      }
      this.newResponse[index].dataSource = new MatTableDataSource<any>(
        element.columns
      );
    }
    this.dialogRef?.close();
  }

  regenerateMetadata(element: any) {
    this.descriptionLoading = true;
    let metadataArray: any = localStorage.getItem('metadataArray');
    let parsed_metadataArray = JSON.parse(metadataArray);

    const filteredMetadataArrayResponse = parsed_metadataArray.filter(
      (e: any) =>
        e.database_name == element.database_name &&
        e.schemas[0].schema_name == element.schema_name &&
        e.schemas[0].tables[0].table_name == element.table_name
    );

    const filteredResponse = this.newResponse.filter(
      (e: any) =>
        e.database_name == element.database_name &&
        e.schema_name == element.schema_name &&
        e.table_name == element.table_name
    );

    const filteredColumn = filteredResponse[0].columns.filter(
      (column: any) => column.checked == true
    );

    if (filteredColumn.length == 0) {
      this.toastr.error(
        'Please select atleast one column of classified metadata to regenerate',
        'Error'
      );
      return;
    }

    let selectedColumns: any = [];
    let customInstructionDescription: any = [];
    for (let el of filteredColumn) {
      selectedColumns.push(el.column_name);
      customInstructionDescription.push(el.user_instruction);
    }
    const filteredObject: any = Object.fromEntries(
      Object.entries(filteredResponse[0].oldColumns).filter(([key]) =>
        selectedColumns.includes(key)
      )
    );

    Object.entries(filteredObject).forEach(([key, value], index) => {
      if (customInstructionDescription[index]) {
        filteredObject[key].user_instruction =
          customInstructionDescription[index];
      } else {
        filteredObject[key].user_instruction = '';
      }
    });

    const filteredOriginalMetadataObject = Object.fromEntries(
      Object.entries(
        filteredMetadataArrayResponse[0].schemas[0].tables[0].columns
      ).filter(([key]) => selectedColumns.includes(key))
    );

    let original_metadata;
    for (let i = 0; i < parsed_metadataArray.length; i++) {
      if (element.database_name == parsed_metadataArray[i].database_name) {
        original_metadata = parsed_metadataArray[i];
        for (let j = 0; j < parsed_metadataArray[i].schemas.length; j++) {
          if (
            element.schema_name ==
            parsed_metadataArray[i].schemas[j].schema_name
          ) {
            original_metadata.schemas = [parsed_metadataArray[i].schemas[0]];
            for (
              let k = 0;
              k < parsed_metadataArray[i].schemas[0].tables.length;
              k++
            ) {
              if (
                element.table_name ==
                parsed_metadataArray[i].schemas[0].tables[0].table_name
              ) {
                delete parsed_metadataArray[i].schemas[0].tables[0]['metaData'];
                parsed_metadataArray[i].schemas[0].tables[0].columns =
                  filteredOriginalMetadataObject;
                original_metadata.schemas[0].tables = [
                  parsed_metadataArray[i].schemas[0].tables[0],
                ];
                this.original_metadata = { ...original_metadata };
              }
            }
          }
        }
      }
    }
    let fetched_metadata;
    for (let i = 0; i < this.fetchedResponse.length; i++) {
      if (element.database_name == this.fetchedResponse[i].database_name) {
        fetched_metadata = this.fetchedResponse[i];
        for (let j = 0; j < this.fetchedResponse[i].schemas.length; j++) {
          if (
            element.schema_name ==
            this.fetchedResponse[i].schemas[j].schema_name
          ) {
            fetched_metadata.schemas = [this.fetchedResponse[i].schemas[j]];
            for (
              let k = 0;
              k < this.fetchedResponse[i].schemas[j].tables.length;
              k++
            ) {
              if (
                element.table_name ==
                this.fetchedResponse[i].schemas[j].tables[k].table_name
              ) {
                delete this.fetchedResponse[i].schemas[j].tables[k]['metaData'];
                this.fetchedResponse[i].schemas[j].tables[k].columns =
                  filteredObject;
                fetched_metadata.schemas[0].tables = [
                  this.fetchedResponse[i].schemas[j].tables[k],
                ];
                this.current_processed_metadata = { ...fetched_metadata };
              }
            }
          }
        }
      }
    }
    if (this.original_metadata && this.current_processed_metadata) {
      let payload = {
        original_metadata: {
          databases: [this.original_metadata],
        },
        current_processed_metadata: {
          databases: [this.current_processed_metadata],
        },
      };

      this.regenerateSubscription = this.generateClassificationService
        .regenerateMetadata(payload)
        .subscribe((response: any) => {
          this.descriptionLoading = false;
          if (response.status == 'success') {
            localStorage.setItem('llm_processing', response.llm_processing);
            this.fetchedResponse = [...response.llm_processing.data.databases];
            let mainResponse = response.llm_processing.data.databases;

            for (let i = 0; i < this.newResponse.length; i++) {
              if (
                this.newResponse[i].database_name ==
                mainResponse[0].database_name &&
                this.newResponse[i].schema_name ==
                mainResponse[0].schemas[0].schema_name &&
                this.newResponse[i].table_name ==
                mainResponse[0].schemas[0].tables[0].table_name
              ) {
                const keys = Object.keys(
                  mainResponse[0].schemas[0].tables[0].columns
                );

                let columns = this.newResponse[i].columns;
                for (let key of keys) {
                  let updatedColumn = {
                    ...mainResponse[0].schemas[0].tables[0].columns[key],
                  };
                  updatedColumn.checked = true;
                  updatedColumn.column_name = key;
                  columns.forEach((el: any, i: number) => {
                    if (el.column_name === key) columns[i] = updatedColumn;
                  });
                }

                this.newResponse[i].columns = columns;
                this.newResponse[i].dataSource = new MatTableDataSource<any>(
                  columns
                );
              }
            }

            this.toastr.success(
              'Metadata has been regenerated',
              'Regeneration Successful'
            );
          }
        });
    }
  }

  openDescriptionDialog(item: any, column: any) {
    for (let element of this.newResponse) {
      if (
        element.database_name == item.database_name &&
        element.schema_name == item.schema_name &&
        element.table_name == item.table_name
      ) {
        for (let ds of element.columns) {
          if (ds.column_name == column.column_name) {
            this.columnDescriptionFull = column.user_instruction;
            this.selectedTableForDescription = item;
            this.selectedColumnForDescription = column;
          }
        }
      }
    }
    this.dialogRef = this.dialog.open(this.columnDescriptionDialog, {
      width: '800px',
      maxWidth: '90vw',
      height: 'auto',
      maxHeight: '90vh',
      disableClose: true,
      panelClass: 'description-dialog-panel',
    });
  }

  openDownloadOptions() {
    this.dialogRef = this.dialog.open(this.downloadOptionDialog, {
      width: '800px',
      maxWidth: '90vw',
      height: 'auto',
      maxHeight: '90vh',
      disableClose: true,
      panelClass: 'description-dialog-panel',
    });
  }

  exportZip(): void {
    let zipArray: any = [];
    this.newResponse.forEach((item: any, index: number) => {
      const columnsToExport = item.columns.filter(
        (column: any) => column.checked == true
      );
      if (columnsToExport.length == 0) {
        this.toastr.error(
          'Please select atleast one column of classified metadata to download',
          'Error'
        );
        return;
      }
      zipArray.push({
        name: item.table_name,
        rows: columnsToExport,
        columns: [
          { key: 'column_name', header: 'Column Name' },
          { key: 'snowflake_description', header: 'Snowflake Description' },
          { key: 'user_instruction', header: 'User Instruction' },
          {
            key: 'ai_generated_description',
            header: 'AI Generated Description',
          },
          {
            key: 'ai_generated_classification',
            header: 'AI Generated Classification',
          },
          { key: 'ai_reasoning', header: 'AI Reasoning' },
          { key: 'confidence_score', header: 'Confidence Score' }
        ],
      });
    });
    this.zipCsv.exportCsvZipFromArrays(zipArray, 'tables.zip');
    this.dialogRef?.close();
  }

  ngOnDestroy(): void {
    // Unsubscribe to avoid memory leaks
    if (this.saveMetadataSubscription) {
      this.saveMetadataSubscription.unsubscribe();
    }
    if (this.atlanBulkDownloadSubscription) {
      this.atlanBulkDownloadSubscription.unsubscribe();
    }
    if (this.regenerateSubscription) {
      this.regenerateSubscription.unsubscribe();
    }
  }
}

@Component({
  selector: 'download-dialog',
  templateUrl: 'dialog.component.html',
  imports: [MatDialogModule, MatButtonModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
})
export class DialogOverviewExampleDialog {
  constructor(
    public dialogRef: MatDialogRef<DialogOverviewExampleDialog>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  onNoClick(): void {
    this.dialogRef.close();
  }
}

@Component({
  selector: 'delete-table-description-dialog',
  templateUrl: 'delete-table-description-dialog.html',
  imports: [
    MatButtonModule,
    MatDialogActions,
    MatDialogClose,
    MatDialogTitle,
    MatDialogContent,
    MatCardModule,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
})
export class DeleteTableDescriptionDialog {
  constructor(
    public dialogRef: MatDialogRef<DeleteTableDescriptionDialog>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  onCancel(): void {
    this.dialogRef.close();
  }

  onOk(): void {
    const resultData = { confirmed: true };
    this.dialogRef.close(resultData);
  }
}
